(() => {
  const init = () => document.querySelectorAll('[data-uh-technical]').forEach(root => {
    if (root.dataset.ready) return;
    let data;
    try { data = JSON.parse(root.querySelector('[data-uh-technical-data]').textContent); } catch { return; }
    if (!Array.isArray(data.selections) || !Array.isArray(data.variants)) return;
    const panels = [...root.querySelectorAll('[data-uh-technical-variant]')];
    const update = sku => {
      const selection = data.selections.find(s => s.sku === sku) || data.selections.find(s => s.sku === data.default_sku);
      if (!selection || !selection.variant_ids.length) return;
      panels.forEach(panel => { panel.hidden = !selection.variant_ids.includes(panel.dataset.uhTechnicalVariant); });
      root.querySelector('[data-uh-technical-multiple]').hidden = selection.variant_ids.length < 2;
      root.querySelector('[data-uh-technical-limited]').hidden = !selection.limited;
      const summary = document.querySelector('[data-uh-config-summary]');
      root.querySelector('[data-uh-technical-selection]').textContent = summary?.textContent || data.title;
    };
    root.dataset.ready = 'true';
    document.addEventListener('uh:configuration-change', event => {
      if (event.detail?.modelSku === data.model_sku) update(event.detail.sku);
    });
    update(document.querySelector('[data-uh-purchase]')?.dataset.selectedSku || document.querySelector('[data-uh-variant-sku]')?.value || new URLSearchParams(location.search).get('konfiguration'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
